export function intersection(arr: string[], selectedKeys: Set<string>) {
  return arr.filter(s => selectedKeys.has(s));
}
